import React from "react";
import AboutSection from "./AboutSection/AboutSection";
import MarqueeSection from "./MarqueeSection/MarqueeSection";
import StrengthStats from "./StrengthStats/StrengthStats";
import HeroSection from "./HeroSection/HeroSection";
import HowWeWork from "./HowWeWork/HowWeWork";
import BrandMarquee from "./BrandMarquee/BrandMarquee";
import OurServices from "./OurServices/OurServices";
import OurWorks from "./OurWorks/OurWorks";
import InstagramFeed from "./InstagramFeed/InstagramFeed";
import YourProjectContect from "./YourProjectContact/YourProjectContact";
import Testimonial from "./Testimonial/Testimonial";
import FAQ from "./FAQSection/FAQ";
import { useGetSettingsQuery } from "../../../redux/api/SettingsApi/settingsApi";
import SEO from "../../../Components/SEO";

const LandingPage = () => {
  const { data: settings } = useGetSettingsQuery();

  return (
    <>
      <SEO
        title={
          settings?.meta_title ||
          "Ideal Corporate Services | Innovative Digital Solutions"
        }
        description={settings?.meta_description}
        keywords={settings?.meta_keyword}
      />
      <HeroSection />
      <MarqueeSection />
      <AboutSection />
      <StrengthStats />
      <BrandMarquee />
      <OurServices />
      <HowWeWork />
      <OurWorks />
      <InstagramFeed />
      <Testimonial />
      <FAQ />
      <YourProjectContect />
    </>
  );
};

export default LandingPage;
